export default __webpack_public_path__ + "static/media/eindexAndEmotions.643147a8.png";